// extracted by mini-css-extract-plugin
export default {"catalogue-version":"Wj60DMNe6XvPKsDvaOIt"};